export const getBaseUrl = () => {
  if (process.env.FIREBASE_HOSTING) return 'https://qa-app.over-haul.com';
  if (process.env.NODE_ENV !== 'development') return '';

  if (process.env.REMOTE) {
    const portalName = window.location.hostname.split('.')[0];
    return `https://${portalName === 'localhost' ? 'qa-app' : portalName}.over-haul.com`;
  } else {
    return window.location.origin.replace('5000', '3000');
  }
};

export const getPortalName = () => {
  if (process.env.FIREBASE_HOSTING) return 'qa-app.over-haul.com';
  if (process.env.NODE_ENV !== 'development') return window.location.hostname;

  if (process.env.REMOTE) {
    const portalName = window.location.hostname.split('.')[0];
    return `${portalName === 'localhost' ? 'qa-app' : portalName}.over-haul.com`;
  }
  else {
    return window.location.host.replace('5000', '3000');
  }
};

export const getAuthUrl = () => {
  if (process.env.NODE_ENV !== 'development' || process.env.REMOTE) {
    return process.env.AUTH_URL || '';
  }

  return 'http://localhost:3001';
};

export const getNotificationUrl = () => {
  if (process.env.NODE_ENV !== 'development' || process.env.REMOTE) {
    return process.env.NOTIFICATION_URL || '';
  }

  return 'http://localhost:3002';
};

export const makeUrl = (apiUrl: string) => {
  if (apiUrl.substring(0, 4) === 'http') {
    return apiUrl;
  }
  return getBaseUrl() + apiUrl;
};

export const getBaseRedirectUrl = () => {
  if (process.env.NODE_ENV === 'development') return `${window.location.protocol}//localhost:${window.location.port}`;
  if (process.env.FRONT_ENV === 'prod') return 'https://app.over-haul.com';
  if (process.env.FRONT_ENV === 'stage') return 'https://stage.over-haul.com';
  return 'https://qa-app.over-haul.com';
};

const MAIN_APP_DOMAIN_DOMAIN = '.over-haul.com';
/**
 * 
 * @returns the main app domain, e.g. '.over-haul.com' for production or '.local.com' for development
 */
export const getMainAppDomain = () => {
  if (process.env.NODE_ENV !== 'development') return MAIN_APP_DOMAIN_DOMAIN;
  const hostnameParts = window.location.hostname.split('.');
  return hostnameParts.length > 1 ? `.${hostnameParts.slice(1).join('.')}` : window.location.hostname;
};
